import {create} from "apisauce";

// const BackServer = "http://localhost:8080"

// const BackServer = "https://chatnewsai.com"

 const BackServer = "https://chatnewsai.onrender.com"

const API = create({
  baseURL: `${BackServer}/api`,
  headers: {
    Authorization: "00000"
  }
})

export const ask = (message) => API.post('/ask', {
  session_id: "WQg1awr9vDgnRKTgi78N-n0PTM_t3mk6Opk62ra6fbBm-_B8idEUrDkKWaF-2qbqCS7jZg.",
  message,
})

